import {
  Button,
  Content,
  Dialog,
  DialogTrigger,
  Divider,
  Flex,
  Heading,
  Text,
  View,
} from "@adobe/react-spectrum";
import { SpeedDialData } from "../../../types/generic.types";

interface DeleteSpeedDialDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  contactToDelete: SpeedDialData | null;
  loading?: boolean;
}

const DeleteSpeedDialDialog = ({
  isOpen,
  onClose,
  onDelete,
  contactToDelete,
  loading = false,
}: DeleteSpeedDialDialogProps) => {
  
  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onClose}>
      <div />
      <Dialog width="400px">
        <Heading>Delete Contact</Heading>
        <Divider />
        <Content width={"300px"}>
          <Text>
            Are you sure you want to delete this contact?
            {contactToDelete && (
              <View marginTop="size-200">
                <Text UNSAFE_style={{ fontWeight: "bold" }}>
                  {contactToDelete.firstName} {contactToDelete.lastName}
                </Text>
                <Text>&nbsp;{contactToDelete.phoneNumber}</Text>
              </View>
            )}
          </Text>
          <Flex gap="size-200" justifyContent="end" marginTop="size-300">
            <Button variant="secondary" onPress={onClose} isDisabled={loading}>
              Cancel
            </Button>
            <Button variant="negative" onPress={onDelete} isDisabled={loading}>
              {loading ? "Deleting..." : "Delete"}
            </Button>
          </Flex>
        </Content>
      </Dialog>
    </DialogTrigger>
  );
};

export default DeleteSpeedDialDialog;
